// src/components/RightPanel/NavBar.js
import React, { useState } from 'react';
import SidebarToggle from '../elements/SidebarToggle';
import UserAccountIcon from '../elements/UserAccountIcon';
import CitySelectorModal from '../modals/CitySelectorModal';
import useAppStore from '../../contexts/useAppStore';
import useUserLocationStore from '../../contexts/useUserLocationStore';

const NavBar = () => {
  const isSidebarOpen = useAppStore((state) => state.isSidebarOpen);
  const [isCityModalOpen, setIsCityModalOpen] = useState(false);
  const { userSelectedCity } = useUserLocationStore();

  const openCityModal = () => setIsCityModalOpen(true);
  const closeCityModal = () => setIsCityModalOpen(false);

  return (
    <div className="h-12 p-4 bg-gray-200 flex justify-between items-center">
      <div className="flex items-center space-x-2">
        {!isSidebarOpen && <SidebarToggle />}
        <span>
          {userSelectedCity?.name 
            ? `Exploring ${userSelectedCity.name}` 
            : 'Select a city'}
        </span>
      </div>
      <div className="flex items-center space-x-4">
        <button
          onClick={openCityModal}
          className="text-sm font-bold text-[var(--brandsecondary)]"
        >
          Switch City
        </button>
        <UserAccountIcon />
      </div>
      <CitySelectorModal isOpen={isCityModalOpen} onClose={closeCityModal} />
    </div>
  );
};

export default NavBar;
